module.exports = __webpack_public_path__ + "img/classifyIco9.1b406b0d.png";